import { render, staticRenderFns } from "./Companys.vue?vue&type=template&id=50125895&scoped=true"
import script from "./Companys.vue?vue&type=script&lang=js"
export * from "./Companys.vue?vue&type=script&lang=js"
import style0 from "./Companys.vue?vue&type=style&index=0&id=50125895&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50125895",
  null
  
)

export default component.exports